<template>
  <div class="container">
		<!-- Header -->
		<div class="header">
			<div :class="['mask hidden', {active: menuHandle}]" @click="menuHandle = !menuHandle"></div>
			<div class="w1600 d-flex j-sb a-center">
				<!-- logo -->
				<div class="logo pr">
					<a class="ab opacity0 pointer" v-show="!$store.state.isLogin" @click="goToPage('/')"></a>
					<!-- 登录后 -->
					<a class="ab opacity0 pointer" v-show="$store.state.isLogin" @click="goToPage('/loginHome')"></a>
					<img src="@/assets/Home/logo2.svg" alt="">
					
				</div>
				<!-- 右侧内容 -->
				<div class="tRightContent d-flex a-center">
					<!-- 栏目 -->
					<nav :class="{active: menuHandle}">
						<ul class="d-flex a-center">
							<li @click="goToPageMenu(item.url)" :class="{active: current(item.url)}" v-for="(item, index) in menuList" :key="index"><a href="javascript:;" class="font18">{{item.column}}</a></li>
						</ul>
					</nav>
					<div class="text d-flex a-center">
						<!-- 登录注册 -->
						<div class="tLogin">
							<!-- 已登录 -->
							<a v-show="$store.state.isLogin" class="pointer" @click="goToPage('/admin')">{{$store.state.member.sexual}}{{$store.state.member.name}}</a>
							<!-- 未登录 -->
							<a v-show="!$store.state.isLogin" class="pointer" @click="goToPage('/login')">{{ $t('show.loginAndRegister') }}</a>
						</div>
						<!-- 语言 -->
						<a href="https://www.univista-isg.com/" target="_blank" class="lang font18 cor999 pr line-sm pointer">
							官网
							<!-- {{lang == 'zh_CN' ? '中文' : 'EN'}} -->
							<!-- <div class="lDown t-center">
								<p>
									<a @click="tabLang('zh_CN')" class="cor999 link pointer">中文</a>
									<a @click="tabLang('EN')" class="cor999 link pointer">EN</a>
								</p>
							</div> -->
						</a>
					</div>
					<!-- 手机端按钮 -->
					<div :class="['menuBtn f-colu a-center hidden', {active: menuHandle}]" @click="menuHandle = !menuHandle">
					    <span class="one"></span>
					    <span class="two"></span>
					    <span class="three"></span>
					</div>
				</div>
			</div>
		</div>
		<!-- end -->
		
		<!-- 路由 -->
		<div class="mainContainer">
			<router-view></router-view>
		</div>
		<!-- end -->
		
		<!-- Footer -->
		<div class="footer">
			<div class="ftTop d-flex">
				<div class="fLogo d-flex a-center">
					<a href=""><img src="@/assets/Home/logo.svg" alt=""></a>
				</div>
				<div class="ftNav d-flex a-center">
					<ul class="d-flex j-sb w100">
						<li @click="goToPage(item.url)" v-for="(item, index) in menuList" :key="index"><a class="font18 corfff" href="">{{item.column}}</a></li>
					</ul>
				</div>
			</div>
			<!-- bottom -->
			<div class="ftBottom d-flex" v-if="content.phone">
				<div class="leftText d-flex">
					<dl class="d-flex j-center f-colu">
						<dt class="line-sm font14 corfff">{{content.phone[0].title}}</dt>
						<dd class="font22 corfff">{{content.phone[0].description}}</dd>
					</dl>
					<dl class="d-flex j-center f-colu">
						<dt class="line-sm font14 corfff">{{content.address[0].title}}</dt>
						<dd class="font14 corfff line-sm" v-html="content.address[0].description"></dd>
					</dl>
				</div>
				<div class="begin corfff line-sm font14 d-flex a-center">
					<p v-html="content.copyright[0].description"></p>
					
				</div>
			</div>
		</div>
		<!-- end -->
  </div>
</template>

<script>
// vuex
import { mapMutations } from 'vuex'
export default {
  name: 'Home',
  components: {
    
  },
  data() {
	  return {
		  menuHandle: false, // 控制移动端导航的显示/隐藏
		  // 导航列表
		  menuList: [
			  {id: 1, column: this.$t('topMenu.product'), url: '/product'},
			  {id: 2, column: this.$t('topMenu.documentDownload'), url: '/document'},
			  {id: 3, column: this.$t('topMenu.onlineTraining'), url: '/onlineTrain'},
			  {id: 4, column: this.$t('topMenu.frequentlyAskedQuestion'), url: '/question'},
			  {id: 5, column: this.$t('adminMenu.feedback'), url: '/feedback'},
			  {id: 6, column: this.$t('topMenu.activity'), url: '/activity'}
		  ],
		  lang: localStorage.getItem('ilang') || 'zh_CN', // 语言
		  // 详细内容
		  content: {}
	  }
  },
  
  computed: {
	  // 导航当前样式
	  current: function() {
		  return function(url) {
			  return this.$route.path.indexOf(url) >= 0 ? true : false;
			 
		  }
	  },
	  
  },
  
  created() {
	// 获取详细信息
	this.getContentInfo();  
  },
  
  methods: {
	  // vuex
	  ...mapMutations(['changeState']),
	  
	  // 页面跳转
	  goToPage(path, query={}) {
		  this.$router.push({
		  	path,
			query
		  })
	  },
	  
	  // 导航点击跳转
	  goToPageMenu(path) {
		  this.menuHandle = false;
		  this.$router.push({
		  	path
		  })
	  },
	  
	  // 获取详细信息
	  getContentInfo() {
		  this.$axios.get(`index/content`)
		  .then(res => {
			  this.content = res.data;
		  })
		  .catch(err=>{})
	  },
	  
	  // 切换语言
	  tabLang(l) {
		  this.lang = l;
		  localStorage.setItem('ilang', l);
		  this.$i18n.locale = l;
		  this.changeState({
		  	lang: l
		  });
		  window.location.reload();
	  }
  }
}
</script>

<style lang="less" scoped>
	.header{
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		z-index: 10;
		background: #fff;
		@media screen and (max-width: 1200px) {
			border-bottom: solid 1px #eee;
		}
		> .mask{
			position: fixed;
			left: 0;
			top: .9rem;
			height: calc(100% - .9rem);
			z-index: 12;
			width: 100%;
			&.active{
				display: block;
			}
			@media screen and (max-width: 1200px) {
				top: .6rem;
				height: calc(100% - .6rem);
			}
		}
		.w1600{
			height: .9rem;
			@media screen and (max-width: 1200px) {
				height: .6rem;
			}
		}
		.logo {
			img{
				height: .65rem;
				@media screen and (max-width: 1200px) {
					height: .45rem;
				}
			}
		}
		.tRightContent{
			nav{
				ul{
					li{
						position: relative;
						&:not(:last-child) {
							margin-right: 0.6rem;
						}
						&:hover a,&.active a{
							color: #2048d7;
						}
						&:hover:after,&.active:after{
							content: "";
							display: block;
							position: absolute;
							left: 0;
							bottom: 0;
							width: 100%;
							height: 2px;
							background: #2048d7;
						}
						a{
							line-height: .9rem;
							display: block;
						}
					}
				}
				@media screen and (max-width: 1200px) {
					position: fixed;
					left: -250px;
					top: .6rem;
					width: 250px;
					height: calc(100% - .6rem);
					background: #fff;
					z-index: 15;
					padding-top: 0.3rem;
					overflow-y: auto;
					transition: all .5s;
					margin-top: 0;
					&.active{
						left: 0;
					}
					ul{
						display: block;
						li{
							&:not(:last-child) {
								margin-right: 0;
								border-bottom: solid 1px #e4e4e4;
							}
							&:hover:after,&.active:after{
								display: none;
							}
							a{
								padding: 0.2rem 0.3rem;
								line-height: 1;
							}
						}
					}
				}
			}
			.text{
				margin-left: 1.6rem;
				.tLogin {
					margin-right: .2rem;
					padding-right: .2rem;
					background: url(@/assets/Icons/tLine.png) no-repeat right center/auto .15rem;
					a{
						display: block;
						width: 1.3rem;
						height: .35rem;
						color: #fff;
						line-height: .35rem;
						border-radius: .35rem;
						background: #2657db url(@/assets/Icons/login.png) no-repeat .15rem center/.15rem;
						text-indent: .4rem;
					}
					
				}
				.lang{
					min-width: 1rem;
					padding: 0 .25rem 0 .3rem;
					background: url(@/assets/Icons/lang.png) no-repeat 0 center/.2rem;
					//,url(@/assets/Icons/arrowDownGray.png) no-repeat right center/.15rem
					&:hover{
						.lDown{
							display: block;
						}
					}
					.lDown{
						position: absolute;
						top: 100%;
						width: 1.5rem;
						padding-top: .2rem;
						left: 50%;
						transform: translateX(-50%);
						display: none;
						z-index: 10;
						p{
							background: #fff;
							border-radius: 5px;
							box-shadow: 0 0 5px rgba(0,0,0,.1);
							padding: 0 0.2rem;
							a{
								display: block;
								padding: 0.1rem;
								border-bottom: solid 1px #e4e4e4;
								font-size: .14rem;
								&:last-child{
									border-bottom: 0;
								}
							}
						}
						@media screen and (max-width: 1200px) {
							padding-top: .1rem;
						}
					}
				}
				@media screen and (max-width: 1200px) {
					margin-left: 0;
				}
			}
		}
	}
	.mainContainer{
		margin-top: .9rem;
		@media screen and (max-width: 1200px) {
			margin-top: .6rem;
		}
	}
	.footer{
		background: #263c93;
		.fLogo,.leftText{
			padding-left: 1.6rem;
			height: 1.3rem;
			width: 50%;
		}
		.leftText{
			padding-left: 0;
		}
		.begin,.ftNav{
			padding-right: 1.6rem;
			height: 1.3rem;
			width: 50%;
		}
		.ftTop{
			border-bottom: solid 1px rgba(255,255,255,.1);
			.fLogo img{
				height: .7rem;
			}
			.ftNav{
				padding-left: .5rem;
				border-left: solid 1px rgba(255,255,255,.1);
			}
		}
		.ftBottom{
			.begin{
				padding-left: .5rem;
				border-left: solid 1px rgba(255,255,255,.1);
				background: #223686;
			}
		}
		.leftText{
			dl{
				width: 50%;
				padding-right: 0.3rem;
				dt{
					margin-bottom: 0.1rem;
				}
				&:first-child{
					padding-left: 1.6rem;
					dt{
						background: url(@/assets/Icons/tel.png) no-repeat .6rem center/.15rem;
					}
				}
				&:last-child{
					border-left: solid 1px rgba(255,255,255,.1);
					padding-left: .3rem;
					dt{
						background: url(@/assets/Icons/address.png) no-repeat .6rem center/.15rem;
						
					}
				}
			}
		}
		@media screen and (max-width: 1600px) {
			.fLogo{
				padding-left: 2.5%;
			}
			.begin,.ftNav{
				padding-right: 2.5%;
			}
			.leftText{
				dl{
					&:first-child{
						padding-left:5%;
					}
				}
			}
		}
		@media screen and (max-width: 1200px) {
			padding-top: .3rem;
			.fLogo,.leftText{
				padding-left: 2.5%;
				height: auto;
				width: 100%;
			}
			.ftTop{
				display: block;
				.fLogo img{
					height: .45rem;
				}
				.ftNav{
					padding: .3rem 2.5%;
				}
			}
			.begin,.ftNav{
				height: auto;
				width: 100%;
			}
			.ftBottom{
				display: block;
				.begin{
					padding: .3rem 2.5%;
				}
			}
			.leftText{
				dl{
					width: 100%;
					padding-right: 0.3rem;
					padding-top: .2rem;
					padding-bottom: .2rem;
					&:first-child{
						padding-left: 0;
					}
					&:last-child{
						padding-left: .4rem;
					}
				}
			}
		}
	}
	/* 手机端头部按钮 */
	.menuBtn span{
		display: block;
		width: 22px;
		height: 2px;
		background: #999;
		margin-top: 5px;
		transition: all .5s;
		margin-left: .15rem;
	}
	.menuBtn span:nth-of-type(1) {
		margin-top: 0;
	}
	.menuBtn.active .two{
		transform: scale(0);
	}
	.menuBtn.active .one{
		transform: rotateZ(-45deg) translateX(-10px);
	}
	.menuBtn.active .three{
		transform: rotateZ(45deg) translateX(-10px);
	}
	@media screen and (max-width: 1200px) {
		.menuBtn{
			display: block;
		}
	}
</style>
